import { Component } from "react";
import PropTypes from "prop-types";

import "./styles/FontAwesomeIconPicker.module.scss";

/**
 * A React icon picker component for the font-awesome icon library.
 *
 *
 * @param {Boolean} [border=false] Whether or not to show a border radius
 * @type {React}
 */
export default class FontAwesomeIconPicker extends Component {
    static propTypes = {
        name: PropTypes.string,
        onChange: PropTypes.func,
    };

    constructor(props) {
        super(props);

        this.state = {
            name: props.name,
        };
    }

    handleChange = (name) => {
        this.setState({name: name});
        if (this.props.onChange) {
            this.props.onChange(name);
        }
    };

    componentDidMount() {
        this.setState({
            FontIconPicker: require("@fonticonpicker/react-fonticonpicker"),
        })
    }

    render() {
        let iconPicker = <div/>;
        if (this.state.FontIconPicker) {
            // Only require this on the BROWSER side.  No server rendering required.  DO NOT put this require()
            // statement in the top of this file.
            const props = {
                icons: [
                    "fab fa-accessible-icon",
                    "fas fa-ambulance",
                    "fas fa-american-sign-language-interpreting",
                    "fas fa-anchor",
                    "fas fa-angle-double-down",
                    "fas fa-angle-double-left",
                    "fas fa-angle-double-right",
                    "fas fa-angle-double-up",
                    "fas fa-angle-down",
                    "fas fa-angle-left",
                    "fas fa-angle-right",
                    "fas fa-angle-up",
                    "fas fa-ankh",
                    "fas fa-apple-alt",
                    "fas fa-archive",
                    "fas fa-arrow-alt-circle-down",
                    "far fa-arrow-alt-circle-down",
                    "fas fa-arrow-alt-circle-left",
                    "far fa-arrow-alt-circle-left",
                    "fas fa-arrow-alt-circle-right",
                    "far fa-arrow-alt-circle-right",
                    "fas fa-arrow-alt-circle-up",
                    "far fa-arrow-alt-circle-up",
                    "fas fa-arrow-circle-down",
                    "fas fa-arrow-circle-left",
                    "fas fa-arrow-circle-right",
                    "fas fa-arrow-circle-up",
                    "fas fa-arrow-down",
                    "fas fa-arrow-left",
                    "fas fa-arrow-right",
                    "fas fa-arrow-up",
                    "fas fa-arrows-alt",
                    "fas fa-arrows-alt-h",
                    "fas fa-arrows-alt-v",
                    "fas fa-assistive-listening-systems",
                    "fas fa-atom",
                    "fas fa-audio-description",
                    "fas fa-award",
                    "fas fa-baby-carriage",
                    "fas fa-backward",
                    "fas fa-bahai",
                    "fas fa-balance-scale",
                    "fas fa-balance-scale-left",
                    "fas fa-balance-scale-right",
                    "fas fa-baseball-ball",
                    "fas fa-basketball-ball",
                    "fas fa-bath",
                    "fas fa-bed",
                    "fas fa-beer",
                    "fas fa-bell",
                    "far fa-bell",
                    "fas fa-bell-slash",
                    "far fa-bell-slash",
                    "fas fa-bible",
                    "fas fa-bicycle",
                    "fas fa-biking",
                    "fas fa-binoculars",
                    "fas fa-birthday-cake",
                    "fas fa-blender",
                    "fas fa-blind",
                    "fas fa-bomb",
                    "fas fa-book",
                    "fas fa-book-dead",
                    "fas fa-book-open",
                    "fas fa-book-reader",
                    "fas fa-bookmark",
                    "far fa-bookmark",
                    "fas fa-bowling-ball",
                    "fas fa-braille",
                    "fas fa-briefcase",
                    "fas fa-broadcast-tower",
                    "fas fa-bug",
                    "fas fa-building",
                    "far fa-building",
                    "fas fa-bullhorn",
                    "fas fa-bullseye",
                    "fas fa-bus",
                    "fas fa-calculator",
                    "fas fa-calendar",
                    "far fa-calendar",
                    "fas fa-calendar-alt",
                    "far fa-calendar-alt",
                    "fas fa-camera",
                    "fas fa-camera-retro",
                    "fas fa-candy-cane",
                    "fas fa-car",
                    "fas fa-caret-down",
                    "fas fa-caret-left",
                    "fas fa-caret-right",
                    "fas fa-caret-square-down",
                    "far fa-caret-square-down",
                    "fas fa-caret-square-left",
                    "far fa-caret-square-left",
                    "fas fa-caret-square-right",
                    "far fa-caret-square-right",
                    "fas fa-caret-square-up",
                    "far fa-caret-square-up",
                    "fas fa-caret-up",
                    "fas fa-carrot",
                    "fas fa-cart-arrow-down",
                    "fas fa-chalkboard",
                    "fas fa-chalkboard-teacher",
                    "fas fa-chart-line",
                    "fas fa-chevron-circle-down",
                    "fas fa-chevron-circle-left",
                    "fas fa-chevron-circle-right",
                    "fas fa-chevron-circle-up",
                    "fas fa-chevron-down",
                    "fas fa-chevron-left",
                    "fas fa-chevron-right",
                    "fas fa-chevron-up",
                    "fas fa-church",
                    "fas fa-circle",
                    "far fa-circle",
                    "fas fa-clipboard",
                    "far fa-clipboard",
                    "fas fa-closed-captioning",
                    "far fa-closed-captioning",
                    "fas fa-cloud",
                    "fas fa-cloud-download-alt",
                    "fas fa-cloud-upload-alt",
                    "fas fa-coffee",
                    "fas fa-cog",
                    "fas fa-cogs",
                    "fas fa-compass",
                    "far fa-compass",
                    "fas fa-compress",
                    "fas fa-compress-alt",
                    "fas fa-compress-arrows-alt",
                    "fas fa-cookie",
                    "fas fa-cookie-bite",
                    "fas fa-copy",
                    "far fa-copy",
                    "fas fa-cross",
                    "fas fa-crosshairs",
                    "fas fa-cube",
                    "fas fa-cubes",
                    "fas fa-cut",
                    "fas fa-deaf",
                    "fas fa-dharmachakra",
                    "fas fa-dice",
                    "fas fa-dice-d20",
                    "fas fa-dice-d6",
                    "fas fa-dice-five",
                    "fas fa-dice-four",
                    "fas fa-dice-one",
                    "fas fa-dice-six",
                    "fas fa-dice-three",
                    "fas fa-dice-two",
                    "fas fa-digital-tachograph",
                    "fas fa-directions",
                    "fas fa-dollar-sign",
                    "fas fa-door-closed",
                    "fas fa-door-open",
                    "fas fa-dove",
                    "fas fa-download",
                    "fas fa-draw-polygon",
                    "fas fa-drum",
                    "fas fa-drum-steelpan",
                    "fas fa-dumbbell",
                    "fas fa-eject",
                    "fas fa-envelope",
                    "far fa-envelope",
                    "fas fa-envelope-open",
                    "far fa-envelope-open",
                    "fas fa-eraser",
                    "fas fa-exchange-alt",
                    "fas fa-exclamation",
                    "fas fa-exclamation-circle",
                    "fas fa-exclamation-triangle",
                    "fas fa-expand",
                    "fas fa-expand-alt",
                    "fas fa-expand-arrows-alt",
                    "fas fa-external-link-alt",
                    "fas fa-external-link-square-alt",
                    "fas fa-eye",
                    "far fa-eye",
                    "fas fa-eye-dropper",
                    "fas fa-eye-slash",
                    "far fa-eye-slash",
                    "fas fa-fast-backward",
                    "fas fa-fast-forward",
                    "fas fa-fax",
                    "fas fa-feather",
                    "fas fa-feather-alt",
                    "fas fa-fighter-jet",
                    "fas fa-file",
                    "far fa-file",
                    "fas fa-file-alt",
                    "far fa-file-alt",
                    "fas fa-file-audio",
                    "far fa-file-audio",
                    "fas fa-file-prescription",
                    "fas fa-file-video",
                    "far fa-file-video",
                    "fas fa-film",
                    "fas fa-fire",
                    "fas fa-fire-alt",
                    "fas fa-fire-extinguisher",
                    "fas fa-flag",
                    "far fa-flag",
                    "fas fa-flag-checkered",
                    "fas fa-flask",
                    "fas fa-football-ball",
                    "fas fa-forward",
                    "fas fa-futbol",
                    "far fa-futbol",
                    "fas fa-gamepad",
                    "fas fa-gavel",
                    "fas fa-gem",
                    "far fa-gem",
                    "fas fa-gift",
                    "fas fa-gifts",
                    "fas fa-glass-cheers",
                    "fas fa-glass-martini",
                    "fas fa-glass-whiskey",
                    "fas fa-glasses",
                    "fas fa-globe",
                    "fas fa-golf-ball",
                    "fas fa-gopuram",
                    "fas fa-graduation-cap",
                    "fas fa-guitar",
                    "fas fa-h-square",
                    "fas fa-hamsa",
                    "fas fa-hand-point-down",
                    "far fa-hand-point-down",
                    "fas fa-hand-point-left",
                    "far fa-hand-point-left",
                    "fas fa-hand-point-right",
                    "far fa-hand-point-right",
                    "fas fa-hand-point-up",
                    "far fa-hand-point-up",
                    "fas fa-hand-pointer",
                    "far fa-hand-pointer",
                    "fas fa-hanukiah",
                    "fas fa-hat-wizard",
                    "fas fa-hdd",
                    "far fa-hdd",
                    "fas fa-headphones",
                    "fas fa-headphones-alt",
                    "fas fa-headset",
                    "fas fa-heart",
                    "far fa-heart",
                    "fas fa-heart-broken",
                    "fas fa-heartbeat",
                    "fas fa-helicopter",
                    "fas fa-highlighter",
                    "fas fa-history",
                    "fas fa-hockey-puck",
                    "fas fa-holly-berry",
                    "fas fa-home",
                    "fas fa-hospital",
                    "far fa-hospital",
                    "fas fa-hourglass",
                    "far fa-hourglass",
                    "fas fa-igloo",
                    "fas fa-image",
                    "far fa-image",
                    "fas fa-images",
                    "far fa-images",
                    "fas fa-industry",
                    "fas fa-info",
                    "fas fa-info-circle",
                    "fas fa-jedi",
                    "fas fa-journal-whills",
                    "fas fa-kaaba",
                    "fas fa-key",
                    "fas fa-keyboard",
                    "far fa-keyboard",
                    "fas fa-khanda",
                    "fas fa-landmark",
                    "fas fa-laptop",
                    "fas fa-laptop-code",
                    "fas fa-layer-group",
                    "fas fa-leaf",
                    "fas fa-lemon",
                    "far fa-lemon",
                    "fas fa-level-down-alt",
                    "fas fa-level-up-alt",
                    "fas fa-life-ring",
                    "far fa-life-ring",
                    "fas fa-lightbulb",
                    "far fa-lightbulb",
                    "fas fa-location-arrow",
                    "fas fa-lock",
                    "fas fa-lock-open",
                    "fas fa-long-arrow-alt-down",
                    "fas fa-long-arrow-alt-left",
                    "fas fa-long-arrow-alt-right",
                    "fas fa-long-arrow-alt-up",
                    "fas fa-low-vision",
                    "fas fa-magic",
                    "fas fa-magnet",
                    "fas fa-male",
                    "fas fa-map",
                    "far fa-map",
                    "fas fa-map-marker",
                    "fas fa-map-marker-alt",
                    "fas fa-map-pin",
                    "fas fa-map-signs",
                    "fas fa-marker",
                    "fas fa-medal",
                    "fas fa-medkit",
                    "fas fa-memory",
                    "fas fa-menorah",
                    "fas fa-microchip",
                    "fas fa-microphone",
                    "fas fa-microphone-alt",
                    "fas fa-microphone-alt-slash",
                    "fas fa-microphone-slash",
                    "fas fa-microscope",
                    "fas fa-mitten",
                    "fas fa-mobile",
                    "fas fa-mobile-alt",
                    "fas fa-money-bill",
                    "fas fa-money-bill-alt",
                    "far fa-money-bill-alt",
                    "fas fa-money-check",
                    "fas fa-money-check-alt",
                    "fas fa-moon",
                    "far fa-moon",
                    "fas fa-mosque",
                    "fas fa-motorcycle",
                    "fas fa-mouse-pointer",
                    "fas fa-mug-hot",
                    "fas fa-music",
                    "fas fa-newspaper",
                    "far fa-newspaper",
                    "fas fa-om",
                    "fas fa-paint-brush",
                    "fas fa-paper-plane",
                    "far fa-paper-plane",
                    "fas fa-paperclip",
                    "fas fa-parking",
                    "fas fa-pastafarianism",
                    "fas fa-paste",
                    "fas fa-pause",
                    "fas fa-pause-circle",
                    "far fa-pause-circle",
                    "fas fa-paw",
                    "fas fa-peace",
                    "fas fa-pen",
                    "fas fa-pen-alt",
                    "fas fa-pen-fancy",
                    "fas fa-pen-nib",
                    "fas fa-pencil-alt",
                    "fas fa-phone",
                    "fas fa-phone-alt",
                    "fas fa-phone-square",
                    "fas fa-phone-square-alt",
                    "fas fa-phone-volume",
                    "fas fa-photo-video",
                    "fas fa-place-of-worship",
                    "fas fa-plane",
                    "fas fa-play",
                    "fas fa-play-circle",
                    "far fa-play-circle",
                    "fas fa-plug",
                    "fas fa-plus",
                    "fas fa-plus-square",
                    "far fa-plus-square",
                    "fas fa-podcast",
                    "fas fa-pray",
                    "fas fa-praying-hands",
                    "fas fa-print",
                    "fas fa-puzzle-piece",
                    "fas fa-question-circle",
                    "far fa-question-circle",
                    "fas fa-quidditch",
                    "fas fa-quran",
                    "fas fa-radiation",
                    "fas fa-radiation-alt",
                    "fas fa-random",
                    "fas fa-recycle",
                    "fas fa-redo",
                    "fas fa-redo-alt",
                    "fas fa-reply",
                    "fas fa-reply-all",
                    "fas fa-restroom",
                    "fas fa-retweet",
                    "fas fa-ring",
                    "fas fa-road",
                    "fas fa-rocket",
                    "fas fa-route",
                    "fas fa-rss",
                    "fas fa-rss-square",
                    "fas fa-ruler-combined",
                    "fas fa-ruler-horizontal",
                    "fas fa-ruler-vertical",
                    "fas fa-running",
                    "fas fa-satellite",
                    "fas fa-satellite-dish",
                    "fas fa-save",
                    "far fa-save",
                    "fas fa-school",
                    "fas fa-screwdriver",
                    "fas fa-scroll",
                    "fas fa-sd-card",
                    "fas fa-search",
                    "fas fa-search-minus",
                    "fas fa-search-plus",
                    "fas fa-shapes",
                    "fas fa-share",
                    "fas fa-share-square",
                    "far fa-share-square",
                    "fas fa-shield-alt",
                    "fas fa-ship",
                    "fas fa-shoe-prints",
                    "fas fa-shopping-bag",
                    "fas fa-shopping-basket",
                    "fas fa-shopping-cart",
                    "fas fa-shower",
                    "fas fa-sign-in-alt",
                    "fas fa-sign-language",
                    "fas fa-sign-out-alt",
                    "fas fa-sim-card",
                    "fas fa-skating",
                    "fas fa-skiing",
                    "fas fa-skiing-nordic",
                    "fas fa-skull-crossbones",
                    "fas fa-sleigh",
                    "fas fa-snowboarding",
                    "fas fa-snowflake",
                    "far fa-snowflake",
                    "fas fa-snowplow",
                    "fas fa-sort",
                    "fas fa-sort-alpha-down",
                    "fas fa-sort-alpha-down-alt",
                    "fas fa-sort-alpha-up",
                    "fas fa-sort-alpha-up-alt",
                    "fas fa-sort-amount-down",
                    "fas fa-sort-amount-down-alt",
                    "fas fa-sort-amount-up",
                    "fas fa-sort-amount-up-alt",
                    "fas fa-sort-down",
                    "fas fa-sort-numeric-down",
                    "fas fa-sort-numeric-down-alt",
                    "fas fa-sort-numeric-up",
                    "fas fa-sort-numeric-up-alt",
                    "fas fa-sort-up",
                    "fas fa-space-shuttle",
                    "fas fa-star",
                    "far fa-star",
                    "fas fa-star-and-crescent",
                    "fas fa-star-of-david",
                    "fas fa-step-backward",
                    "fas fa-step-forward",
                    "fas fa-sticky-note",
                    "far fa-sticky-note",
                    "fas fa-stop",
                    "fas fa-stop-circle",
                    "far fa-stop-circle",
                    "fas fa-stopwatch",
                    "fas fa-street-view",
                    "fas fa-stroopwafel",
                    "fas fa-subway",
                    "fas fa-suitcase",
                    "fas fa-sun",
                    "far fa-sun",
                    "fas fa-swimmer",
                    "fas fa-synagogue",
                    "fas fa-sync",
                    "fas fa-sync-alt",
                    "fas fa-table-tennis",
                    "fas fa-tablet",
                    "fas fa-tablet-alt",
                    "fas fa-tachometer-alt",
                    "fas fa-tag",
                    "fas fa-tags",
                    "fas fa-taxi",
                    "fas fa-text-height",
                    "fas fa-text-width",
                    "fas fa-theater-masks",
                    "fas fa-thumbtack",
                    "fas fa-ticket-alt",
                    "fas fa-tint",
                    "fas fa-toilet",
                    "fas fa-toolbox",
                    "fas fa-tools",
                    "fas fa-torah",
                    "fas fa-torii-gate",
                    "fas fa-traffic-light",
                    "fas fa-train",
                    "fas fa-tram",
                    "fas fa-trash",
                    "fas fa-trash-alt",
                    "far fa-trash-alt",
                    "fas fa-tree",
                    "fas fa-trophy",
                    "fas fa-truck",
                    "fas fa-tty",
                    "fas fa-tv",
                    "fas fa-umbrella",
                    "fas fa-undo",
                    "fas fa-undo-alt",
                    "fas fa-universal-access",
                    "fas fa-university",
                    "fas fa-unlock",
                    "fas fa-unlock-alt",
                    "fas fa-upload",
                    "fas fa-user-graduate",
                    "fas fa-utensil-spoon",
                    "fas fa-utensils",
                    "fas fa-video",
                    "fas fa-vihara",
                    "fas fa-volleyball-ball",
                    "fas fa-volume-down",
                    "fas fa-volume-mute",
                    "fas fa-volume-off",
                    "fas fa-volume-up",
                    "fas fa-wallet",
                    "fas fa-weight",
                    "fas fa-wheelchair",
                    "fas fa-wifi",
                    "fas fa-wine-glass",
                    "fas fa-wrench",
                    "fas fa-yin-yang",
                    "fab fa-youtube"
                ],
                theme: "blue",
                value: this.state.name || "",
                onChange: this.handleChange,
                isMulti: false,
                closeOnSelect: true,
            };

            iconPicker = <this.state.FontIconPicker {...props} />;
        }

        return iconPicker;
    }
}
